var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "mask-properties" },
    [
      _setup.hasMask
        ? _c(
            "div",
            { staticClass: "mask-row" },
            [
              !_vm.mixed
                ? _c(_setup.CPreview, {
                    attrs: {
                      src: _setup.previewSource,
                      alt: _setup.maskName,
                      width: 30,
                      "max-height": "30px",
                    },
                    on: { "preview-failed": _setup.onPreviewFailed },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("span", { staticClass: "mask-name" }, [
                _vm._v(_vm._s(_setup.maskName)),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "actions ml-auto" },
                [
                  _c(_setup.CButton, {
                    attrs: {
                      icon: ["fas", "arrows-rotate"],
                      size: "icon",
                      title: "Choose another shape",
                      disabled: _vm.disabled,
                    },
                    on: { click: _setup.openModal },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: {
                      icon: ["fas", "arrow-up-from-bracket"],
                      size: "icon",
                      title: "Upload a new shape",
                      disabled: _vm.disabled || _setup.model.uploading,
                    },
                    on: { click: _setup.openFileUploader },
                  }),
                  _vm._v(" "),
                  _c(_setup.CButton, {
                    attrs: {
                      icon: ["far", "trash-can"],
                      size: "icon",
                      title: "Remove mask",
                      disabled: _vm.disabled,
                    },
                    on: {
                      click: function ($event) {
                        return _setup.emit("remove-mask")
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _c(_setup.CButton, {
            attrs: {
              variant: "secondary",
              text: "Add Mask",
              icon: ["far", "plus"],
              disabled: _vm.disabled || _setup.model.uploading,
            },
            on: { click: _setup.openModal },
          }),
      _vm._v(" "),
      _c(_setup.CFileInput, {
        ref: "fileInputRef",
        staticClass: "d-none",
        attrs: { value: [], accept: _setup.accept, "display-preview": false },
        on: { input: _setup.onFileUpload },
      }),
      _vm._v(" "),
      _setup.model.modalOpen
        ? _c(_setup.MaskSelectorModal, {
            attrs: { "disable-svg": _vm.disableSvg },
            on: {
              select: _setup.onMaskSelected,
              cancel: function ($event) {
                _setup.model.modalOpen = false
              },
              error: function ($event) {
                return _setup.emit("error", $event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }